export enum CouponType {
  PRODUCT = 'product',
  VOUCHER = 'voucher',
  CART = 'cart',
}
